// UTM Parameter Tracking
export interface UTMData {
  utm_source?: string | null;
  utm_medium?: string | null;
  utm_campaign?: string | null;
  utm_content?: string | null;
  utm_term?: string | null;
}

export const captureUTMParameters = (): UTMData => {
  const params = new URLSearchParams(window.location.search);
  
  const utmData: UTMData = {
    utm_source: params.get('utm_source'),
    utm_medium: params.get('utm_medium'),
    utm_campaign: params.get('utm_campaign'),
    utm_content: params.get('utm_content'),
    utm_term: params.get('utm_term'),
  };
  
  // Store in localStorage if any UTM params exist
  if (Object.values(utmData).some(v => v !== null)) {
    console.log('[UTM] Captured UTM parameters:', utmData);
    localStorage.setItem('utm_data', JSON.stringify(utmData));
  }
  
  return utmData;
};

export const getUTMData = (): UTMData | null => {
  const stored = localStorage.getItem('utm_data');
  return stored ? JSON.parse(stored) : null;
};

export const clearUTMData = () => {
  localStorage.removeItem('utm_data');
};
